import { ArrowRightAlt } from "@mui/icons-material";
import { Link } from "react-router-dom";

import { Stack, Box, Grid } from "@mui/material";
import "./HomeScreen.css";
import ImageBox from "../common/ImageBox";
import homeimg from "../common/images/homeimg.jpg";

function AdminHomeScreen() { 
  return (
    <Box sx={{ width: "97%", flexGrow: 1, p: 2 }}>
      <Stack spacing={5}>
        <Box
          sx={{
            height: "60% !important",
            borderRadius: "10px",
            margin: "20px",
          }}
        >
          <ImageBox myclass="homeclass" imageUrl={homeimg}></ImageBox>
        </Box>
        <Grid
          container
          sx={{
            alignContent: "space-evenly",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <Grid item xs={3}>
            <Box
              className="admin-home-links"
              alignItems="center"
              display="flex"
              spacing={2}
            >
              <span className="link-header">Manage Care Facility</span>
              <p>This section is to add, update and delete Care Facilities.</p>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Link to="/admin/careFacilityListings">Manage Care Facility</Link>
                <ArrowRightAlt sx={{ color: "#002d82" }} />
              </div>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box
              className="admin-home-links"
              alignItems="center"
              display="flex"
              spacing={2}
            >
              <span className="link-header">Manage Client User</span>
              <p>
                This section is to add, update and delete Care Facility Users.
              </p>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Link to="/admin/careUserListings">Manage Client User</Link>
                <ArrowRightAlt sx={{ color: "#002d82" }} />
              </div>
            </Box>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
}

export default AdminHomeScreen;
